import { useListenBackgroundRemovalMessage } from "../tools/background-removal";
import { useListenBirdWormsEyeViewMessage } from "../tools/bird-worms-eye-view";
import { useListenCameraMoveAroundMessage } from "../tools/camera-move-around";
import { useListenCameraMultiAngleMessage } from "../tools/camera-multi-angle";
import { useListenChangeRaceMessage } from "../tools/change-race";
import { useListenColorPaletteMessage } from "../tools/color-palette";
import { useListenCommunityToolGenerateMessage } from "../tools/community-tool-generate";
import { useListenExpressionEditMessage } from "../tools/expression-edit";
import { useListenExtractOutfitMessage } from "../tools/extract-outfit";
import { useListenFaceEnhancerMessage } from "../tools/face-enhancer";
import { useListenFaceEnhancerBMessage } from "../tools/face-enhancer-b";
import { useListenFaceSwapMessage } from "../tools/face-swap";
import { useListenFilmGrainMessage } from "../tools/film-grain";
import { useListenGenerateBackgroundMessage } from "../tools/generate-background";
import { useListenGenerateBackgroundAutoMessage } from "../tools/generate-background-auto";
import { useListenGenerateIconMessage } from "../tools/generate-icon";
import { useListenGptEditingMessage } from "../tools/gpt-editing";
import { useListenGptGenerationMessage } from "../tools/gpt-generation";
import { useListenGrabAnythingMessage } from "../tools/grab-anything";
import { useListenHeadPoseControlMessage } from "../tools/head-pose-control";
import { useListenImgToImgMessage } from "../tools/img-to-img";
import { useListenInpaintingMessage } from "../tools/inpainting";
import { useListenKreaSkinFilterMessage } from "../tools/krea-skin-filter";
import { useListenMakeupRemoverMessage } from "../tools/makeup-remover";
import { useListenNanoBananaEditingMessage } from "../tools/nano-banana-editing";
import { useListenNanoBananaGenerationMessage } from "../tools/nano-banana-generation";
import { useListenObjectFusionAMessage } from "../tools/object-fusion-a";
import { useListenObjectFusionBMessage } from "../tools/object-fusion-b";
import { useListenPoseMatcherMessage } from "../tools/pose-matcher";
import { useListenRelightMessage } from "../tools/relight";
import { useListenRemoveLightMessage } from "../tools/remove-light";
import { useListenSeedreamEditingMessage } from "../tools/seedream-editing";
import { useListenSeedreamGenerationMessage } from "../tools/seedream-generation";
import { useListenTypographyMessage } from "../tools/typography";
import { useListenUpscaleImageMessage } from "../tools/upscale-image";
import { useListenVirtualTryOnMessage } from "../tools/virtual-try-on";
import { useListenVirtualTryOnV2Message } from "../tools/virtual-try-on-v2";
import { useListenZImageEnhancerMessage } from "../tools/z-image-enhancer";

export function useToolListeners() {
	useListenUpscaleImageMessage();
	useListenFaceSwapMessage();
	useListenObjectFusionAMessage();
	useListenMakeupRemoverMessage();
	useListenVirtualTryOnMessage();
	useListenObjectFusionBMessage();
	useListenPoseMatcherMessage();
	useListenInpaintingMessage();
	useListenFaceEnhancerMessage();
	useListenImgToImgMessage();
	useListenChangeRaceMessage();
	useListenHeadPoseControlMessage();
	useListenExpressionEditMessage();
	useListenFaceEnhancerBMessage();
	useListenRemoveLightMessage();
	useListenGenerateBackgroundMessage();
	useListenRelightMessage();
	useListenCameraMoveAroundMessage();
	useListenBirdWormsEyeViewMessage();
	useListenCameraMultiAngleMessage();
	useListenNanoBananaGenerationMessage();
	useListenNanoBananaEditingMessage();
	useListenGenerateBackgroundAutoMessage();
	useListenGenerateIconMessage();
	useListenSeedreamGenerationMessage();
	useListenSeedreamEditingMessage();
	useListenGptGenerationMessage();
	useListenGptEditingMessage();
	useListenExtractOutfitMessage();
	useListenVirtualTryOnV2Message();
	useListenGrabAnythingMessage();
	useListenColorPaletteMessage();
	useListenCommunityToolGenerateMessage();
	useListenTypographyMessage();
	useListenFilmGrainMessage();
	useListenZImageEnhancerMessage();
	useListenKreaSkinFilterMessage();
	useListenBackgroundRemovalMessage();
}
